export default __webpack_public_path__ + "static/media/analysis.c988b1cb.png";